up.CannotTarget = class CannotTarget extends up.Error {
};
